<template>
  <div class="welcome-container">
    <!-- Прелоадер -->
    <div v-if="!isVideoLoaded" class="preloader">
      <img
        :src="imageSrc"
        alt="Loading"
        class="preloader-image"
      />
    </div>

    <!-- Фоновое видео -->
    <video
      ref="videoElement"
      class="welcome-video"
      :class="{ 'video-loaded': isVideoLoaded }"
      autoplay
      loop
      muted
      playsinline
      @loadeddata="handleVideoLoaded"
      @canplay="handleVideoLoaded"
    >
      <source :src="videoSrc" type="video/mp4" />
    </video>

    <div v-if="isVideoLoaded" class="welcome-content">
      <div class="welcome-header">        
        <!-- Текст приветствия -->
        <p class="welcome-text" style="font-size: 32px;">
          Welcome, dear <span class="italic-text">{{ firstName }}</span>, track your trading results with <span class="italic-text">HyperLiquid</span>
        </p>
      </div>

      <div class="welcome-actions">
        <BaseButton
          variant="primary"
          size="lg"
          full-width
          @click="handleLaunchApp"
        >
          Launch App
        </BaseButton>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'
import BaseButton from '../components/ui/BaseButton.vue'
import { useTelegramData } from '../composables/useTelegram.js'
import welcomeVideo from '../assets/Wellcome_bg.mp4'
import blobGreenGif from '../assets/blob_green.gif'

export default {
  name: 'WelcomeScreen',
  components: {
    BaseButton
  },
  setup() {
    const router = useRouter()
    const { userData } = useTelegramData()
    const isVideoLoaded = ref(false)
    const videoElement = ref(null)

    const firstName = computed(() => {
      return userData.value.firstName || 'User'
    })

    const handleVideoLoaded = () => {
      isVideoLoaded.value = true
    }

    const handleLaunchApp = () => {
      router.push({ name: 'Profile' })
    }

    return {
      firstName,
      videoSrc: welcomeVideo,
      imageSrc: blobGreenGif,
      isVideoLoaded,
      videoElement,
      handleVideoLoaded,
      handleLaunchApp
    }
  }
}
</script>

<style scoped>
@import '../styles/tokens.css';
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300..700;1,300..700&display=swap');

.welcome-container {
  position: relative;
  min-height: 100vh;
  width: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.preloader {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--color-bg-primary);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
}

.preloader-image {
  max-width: 200px;
  width: 100%;
  height: auto;
  object-fit: contain;
}

.welcome-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;
  opacity: 0;
  transition: opacity 0.5s ease-in;
}

.welcome-video.video-loaded {
  opacity: 1;
}

.welcome-content {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 480px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  padding: var(--spacing-xl) var(--spacing-lg);
}

.welcome-header {
  text-align: center;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: start;
  gap: var(--spacing-xs);
}

.welcome-image-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.welcome-image {
  max-width: 100%;
  width: 50%;
  height: auto;
  object-fit: contain;
}

.welcome-text {
  font-size: 32px;
  font-weight: 500;
  color: var(--color-text-primary);
  margin: 0;
  text-align: center;
  line-height: 1.5;
  max-width: 100%;
}

.italic-text {
  font-family: 'Cormorant Garamond', serif;
  font-style: italic;
  font-weight: 100;
  font-size: 38px;
}

.welcome-actions {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
  margin-top: auto;
}

@media (max-width: 480px) {
  .welcome-text {
    font-size: var(--font-size-base);
  }
  
  .welcome-image {
    max-width: 80%;
  }
}
</style>

